import { createEvent } from "effector";
const OnChangePageSizeEvt = () => {
    const onChangePageSizeEvt = createEvent("OnChangePageSizeEvt");
    onChangePageSizeEvt.watch(() => console.log("OnChangePageSizeEvt"));
    return onChangePageSizeEvt;
};
export default OnChangePageSizeEvt;
//# sourceMappingURL=OnChangePageSizeEvt.js.map